import { useEffect, useState } from 'react';
import { useI18n } from '../i18n';

export interface ListingFilterValues {
  floatMin: string;
  floatMax: string;
  seed: string;
}

interface Props {
  valores: ListingFilterValues;
  onApply: (next: ListingFilterValues) => void;
}

/**
 * Float e pattern como filtros de verdade, separados da ordenação.
 *
 * Os campos são locais até o Enter (ou o botão): filtrar a cada tecla dispararia
 * uma busca por dígito enquanto alguém digita "0.00201673".
 */
export function ListingFilters({ valores, onApply }: Props) {
  const { lang } = useI18n();
  const [min, setMin] = useState(valores.floatMin);
  const [max, setMax] = useState(valores.floatMax);
  const [seed, setSeed] = useState(valores.seed);

  // Quando a URL muda por fora (voltar do navegador, limpar), os campos seguem.
  useEffect(() => {
    setMin(valores.floatMin);
    setMax(valores.floatMax);
    setSeed(valores.seed);
  }, [valores.floatMin, valores.floatMax, valores.seed]);

  const pt = lang === 'pt';
  const aplicar = () => onApply({ floatMin: min.trim(), floatMax: max.trim(), seed: seed.trim() });
  const limpar = () => {
    setMin('');
    setMax('');
    setSeed('');
    onApply({ floatMin: '', floatMax: '', seed: '' });
  };
  const naTecla = (e: React.KeyboardEvent) => e.key === 'Enter' && aplicar();
  const temFiltro = Boolean(valores.floatMin || valores.floatMax || valores.seed);

  return (
    <div className="listing-filters">
      <div className="lf-group">
        <span className="lf-label">Float</span>
        <input
          className="lf-input"
          inputMode="decimal"
          placeholder={pt ? 'mínimo' : 'min'}
          value={min}
          onChange={(e) => setMin(e.target.value)}
          onKeyDown={naTecla}
        />
        <span className="lf-sep">–</span>
        <input
          className="lf-input"
          inputMode="decimal"
          placeholder={pt ? 'máximo' : 'max'}
          value={max}
          onChange={(e) => setMax(e.target.value)}
          onKeyDown={naTecla}
        />
      </div>

      <div className="lf-group">
        <span className="lf-label">Pattern</span>
        <input
          className="lf-input"
          inputMode="numeric"
          placeholder={pt ? 'ex.: 387' : 'e.g. 387'}
          value={seed}
          onChange={(e) => setSeed(e.target.value)}
          onKeyDown={naTecla}
        />
      </div>

      <button className="btn small" onClick={aplicar}>
        {pt ? 'Filtrar' : 'Apply'}
      </button>
      {temFiltro && (
        <button className="btn ghost small" onClick={limpar}>
          {pt ? 'Limpar' : 'Clear'}
        </button>
      )}
    </div>
  );
}
